import React, { createContext, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import useRestApiClient from 'src/hooks/useRestApiClient';

const initialState = {
  locales: ['en-us', 'ja'],
  credential: {}
};

const LocalesContext = createContext({
  ...initialState
});

export const LocalesProvider = (props) => {
  const { children } = props;
  const [locales, setLocales] = useState([]);
  const [loading, setLoading] = useState(true);
  const credential = useRef({});
  const client = useRestApiClient();

  const getLocales = async () => {
    const instanceCred = { user_instance_id: credential.current.id };
    const subdomainCred = {
      subdomain: credential.current.subdomain,
      auth: {
        username: credential.current.email,
        password: credential.current.password
      }
    };

    try {
      setLoading(true);
      const response = await client.post('/locales', {
        credentials: credential.current.id ? instanceCred : subdomainCred
      });
      setLocales(response.data.message);
      setLoading(false);
      return response;
    } catch (error) {
      setLocales([]);
      setLoading(false);
      return error;
    }
  };

  const checkIfSubdomainIsPublic = async (subdomain) => {
    try {
      setLoading(true);
      const response = await client.post('/locales', {
        subdomain
      });
      setLoading(false);
      setLocales(response.data.message);
      return response;
    } catch (error) {
      setLocales([]);
      setLoading(false);
      return error;
    }
  };

  const checkIfSubdomainExists = async (subdomain) => {
    try {
      setLoading(true);
      const response = await client.get(
        `/domain/checker?domain=${subdomain}.zendesk.com`
      );
      return response;
    } catch (error) {
      setLocales([]);
      setLoading(false);
      return error;
    }
  };

  return (
    <LocalesContext.Provider
      value={{
        locales,
        loading,
        getLocales,
        checkIfSubdomainIsPublic,
        checkIfSubdomainExists,
        setZendeskCredential: (data) => {
          credential.current = data;
        }
      }}
      {...props}
    >
      {children}
    </LocalesContext.Provider>
  );
};

LocalesProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default LocalesContext;
